export class SlicesTextAnimation {

  constructor(props = {}) {
    this.name = props.name;
    this.speed = props.speed;
  }

  get ALLOWED_NAMES() {
    return new Set(['', 'fadein', 'typewrite', 'highlight', 'focusin']);
  }
  
  get name() {
    return this['#name'] || Array.from(this.ALLOWED_NAMES)[0];
  }

  set name(name) {
    if(!this.ALLOWED_NAMES.has(name)) return;
    this['#name'] = name;
  }

  get speed() {
    return this['#speed'] || 40;
  }

  set speed(speed=40) {
    this['#speed'] = parseInt(speed);
  }

}